// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"tour__wrapper__3rNuG","container":"tour__container__1c0MW","close":"tour__close__De8B-","header":"tour__header__XVXZf","step":"tour__step__26kRd","content":"tour__content__3h9Uu","ctaWrapper":"tour__ctaWrapper__2fenk","hasCancel":"tour__hasCancel__3vwKD","cta":"tour__cta__Os-6R","cancel":"tour__cancel__3ysuO","tooltip":"tour__tooltip__WeOHX","visible":"tour__visible__1AzzO"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/components/Tour/tour.scss
// module id = 634
// module chunks = 4 6 8 9 12 14 19 21